import { Grid, Paper, useMediaQuery, useTheme } from '@material-ui/core';
import React from 'react';
import { ForgotPasswordFormProps } from '../ForgotPasswordForm';
import Transition from '../../../verticalTransition/components/Transition';
import CommonForgotPasswordLayout from '../genericComponents/CommonForgotPasswodLayout';
import { genericJourneyTheme } from '../../../common/styles/genericJourneyTheme';
import { useTranslation } from 'react-i18next';

const ForgotPasswordFormLayout02 = ({
  value,
  placeholderKey,
  helperText,
  labelKey,
  cancelRoutePath,
  locked,
  inputChangeHandler,
  onResetPasswordClick,
  alert,
  loading,
}: ForgotPasswordFormProps): JSX.Element => {
  const theme = useTheme();
  const genericJourneyClass = genericJourneyTheme();
  const lgUp = useMediaQuery(theme.breakpoints.up('lg'));
  const { t } = useTranslation();

  return (
    <>
      <div className={genericJourneyClass.upLayer}>
        <Transition>
          <Grid item xl={12} lg={12} className={genericJourneyClass.journeyThemeGrid}>
            <Paper elevation={lgUp ? 1 : 0} className={genericJourneyClass.journeyThemePaper}>
              {/* verticalLayoutGrid */}
              <form onSubmit={onResetPasswordClick} aria-label={t(locked ? 'accountLocked' : 'resetPassword')}>
                <Grid container justify="center">
                  <Grid item lg={12} sm={12}>
                    <CommonForgotPasswordLayout
                      value={value}
                      placeholderKey={placeholderKey}
                      helperText={helperText}
                      labelKey={labelKey}
                      alert={alert}
                      locked={locked}
                      loading={loading}
                      cancelRoutePath={cancelRoutePath}
                      inputChangeHandler={inputChangeHandler}
                      onResetPasswordClick={onResetPasswordClick}
                    />
                  </Grid>
                </Grid>
              </form>
            </Paper>
          </Grid>
        </Transition>
      </div>
    </>
  );
};

export default ForgotPasswordFormLayout02;
